import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the DecodedPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'decoded',
})
export class DecodedPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string) {
    return decodeURIComponent(value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/decoded/decoded.ts